export interface NewProductSetting {
    _id: string,
    date: string,
    manufacturer: string,
    manufacturer_name: string,
    country:string,
    country_name:string,
    category:string,
    category_name:string,
    new_products:any[]
}

export const new_product_setting_default = {
    _id: "",
    date: "",
    manufacturer: "",
    manufacturer_name: "",
    country:"",
    country_name: "",
    category:"",
    category_name: "",
    new_products:Array({regions:[],channels:[],outlet_classes:[],retailers:[],identifier_type:[],identifier_id:[],points:[],type:[],target:[]})
}

export interface NewProductSettingDetailFormData {
    _id: string;
    date: string;
    manufacturer: string;
    manufacturer_name: string,
    country:string;
    country_name:string;
    category:string;
    category_name:string;
    new_products:Array<{regions:string[],channels:string[],outlet_classes:string[],retailers:string[],identifier_type:string[],identifier_id:string[],points:number[],type:string[],target:string[]}>
}

export interface NewProductSettingUpdateProps {
    date: string;
    _id: string;
    manufacturer: string;
    country:string;
    category:string;
    new_products:any[];
}

export const updateParams = (params: NewProductSettingUpdateProps) => {
    return {
        _id: params._id,
        date: params.date,
        manufacturer: params.manufacturer,
        country:params.country,
        category:params.category,
        new_products:params.new_products
    };
}